import { render, staticRenderFns } from "./VersionAnchorNav.vue?vue&type=template&id=2bd12e38&scoped=true"
import script from "./VersionAnchorNav.vue?vue&type=script&lang=js"
export * from "./VersionAnchorNav.vue?vue&type=script&lang=js"
import style0 from "./VersionAnchorNav.vue?vue&type=style&index=0&id=2bd12e38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd12e38",
  null
  
)

export default component.exports